import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";

import { ReactComponent as Locomotive } from "./assets/locomotive.svg";
import { ReactComponent as Tanker }  from "./assets/tanker.svg";
import { ReactComponent as OpenHopper }  from "./assets/open_hooper.svg";
import { ReactComponent as Flatcar }  from "./assets/flat_car.svg";
import { ReactComponent as Container }  from "./assets/long_container.svg"
import { ReactComponent as Trailer } from "./assets/trailer_icon_black.svg"
import { ReactComponent as Reefer } from "./assets/reefer.svg"
import { ReactComponent as ClosedHopper }  from "./assets/closed_hooper.svg";
import { ReactComponent as BoxCar }  from "./assets/box_car.svg";
import { ReactComponent as RefrigeratedBoxCar }  from "./assets/refrigerated_boxcar.svg";
import { ReactComponent as WellCar }  from "./assets/well_car.svg";
import { ReactComponent as CenterBeam }  from "./assets/center_beam.svg";
import { ReactComponent as AutoRack }  from "./assets/auto_rack.svg";
import { ReactComponent as Gondola }  from "./assets/gondola.svg";
import { ReactComponent as Maintenance }  from "./assets/maintenance_car.svg";
import { ReactComponent as Passenger }  from "./assets/passenger_car.svg";
import { ReactComponent as CoilCar }  from "./assets/coil_car.svg";


const styles = {
  buildRailcarGrid: {
    width: "100%",
    padding: "0px 5px",

    display: "grid",

    gridTemplateColumns: "50% 50%",
    gridTemplateRows: "15px 15px 17px",
  },

  buildRailcarGridEdit: {
    width: "100%",
    padding: "0px 5px",

    display: "grid",
    gridTemplateColumns: "50% 50%",
    gridTemplateRows: "30px 30px 30px",
  },

  railcarIcon: {
    padding: "0px 2px",
    width: "100%",
    height: "100%",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    fontSize: "14px",
    boxSizing: "border-box",

  },

  selectedUnit: {
    backgroundColor: "#ffa500AA", //#68ac58AA
    borderRadius: "2px"
  },

  hoverRailcar: {
    "& svg:hover": {
        backgroundColor: "#ffa500", //#68ac58CC
        cursor: "pointer",
        borderRadius: "2px",
      }
  },

  railcarIconBottom: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    boxSizing: "border-box",

  },

  tpf: {
    gridArea: "1 / 1 / 2 / 4",
  },
  tp2: {
    gridArea: "1 / 2 / 2 / 3",
  },
  tp1: {
    gridArea: "1 / 1 / 2 / 2",
  },
  btf: {
    gridArea: "2 / 1 / 3 / 4",
  },
  bt2: {
    gridArea: "2 / 2 / 3 / 3",
  },
  bt1: {
    gridArea: "2 / 1 / 3 / 2",
  },

  level0: {
    gridArea: "3 / 1 / 4 / 3" ,
  },

};


const ComplexRailcar = (props) => {
  const { classes, componentType, data, handleSetDisplayCar, selectedUnitId, reverseRailcars } = props;

  const [cargoData, setCargoData] = React.useState([]);
  const [stackedCargo, setStackedCargo] = React.useState(false);

  React.useEffect(() => {
    setCargoData([])
    setStackedCargo(false)

    if (data.cargo.length === 2) {
      if(data.cargo[0].cargoPosition.substring(0,1).localeCompare("B") !== data.cargo[1].cargoPosition.substring(0,1).localeCompare("B")) {
        setStackedCargo(true)
      }
    }

    setCargoData(data.cargo)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, data.cargo])


  const handleSetPosition = pos => {
    if (stackedCargo) {
      if (pos === "B1" || pos === "B2") {
        return classes.btf
      } else if (pos === "T1" || pos === "T2") {
        return classes.tpf
      } 

    } else if (data.cargo && data.cargo.length === 3){
      if (pos === "B1") {
        return classes.bt1
      } else if (pos === "B2") {
        return classes.bt2
      } else if (pos === "T1" || pos === "T2") {
        return classes.tpf
      }
      
    } else {
      if (pos === "B1") {
        return classes.bt1
      } else if (pos === "B2") {
        return classes.bt2
      } else if (pos === "T1") {
        return classes.tp1
      } else if (pos === "T2") {
        return classes.tp1
      } 

    }

  }

  const handleRender = (type, unmatched) => {
    if (type === 171) {
        return <span style={reverseRailcars ? {transform: "scaleX(-1)"} : null}><Locomotive /></span>
      } else if (type === 172) {
        return <Maintenance />
      } else if (type === 173) {
        return <AutoRack />
      } else if (type === 174) {
        return <BoxCar />
      } else if (type === 175) {
        return <RefrigeratedBoxCar />
      } else if (type === 176) {
        return <CenterBeam />
      } else if (type === 177) {
        return <ClosedHopper  />
      } else if (type === 178) {
        return <OpenHopper  />
      } else if (type === 179) {
        return <Gondola />
      } else if (type === 180) {
        return <Tanker />
      } else if (type === 181) {
        return <WellCar width={"100%"} height={"100%"}/>
      } else if (type === 182) {
        return <Flatcar width={"100%"} height={"100%"} color={"#000"}/>
      } else if (type === 184) {
        return <div style={{fontWeight: 500}}>OTHER</div>
      } else if (type === 183) {
        return <Passenger />
      } else if (type === 185) {
        return <CoilCar />
      }
        else if (type === "Container") {
        return <Container width={"100%"} height={"100%"} color={unmatched ? "#EB3C39" : "#757575"}/>
      } else if (type === "Reefer") {
        return <Reefer width={"100%"} height={"100%"}/>
      } else if (type === "Trailer") {
        return <Trailer width={"100%"} height={"100%"}/>
      }
  }

  // MoG color coding
  // Red - #EB3C39
  // Green - #68AC58
  // Yellow - #FFEB3B

  return (
    // Carousel Cards - Small View
    componentType !== "large"  ? <div className={classes.buildRailcarGrid}>
        {
          cargoData[0] ? cargoData.map((c,i) => 
          <div key={i} className={`${classes.railcarIcon} ${handleSetPosition(c.cargoPosition)}`} >
            {handleRender(c.cargoType, c.cargoProfileId.substring(0, 4).localeCompare("0000") === 0)}
          </div>) : null
        }

        <div className={`${classes.railcarIconBottom} ${classes.level0}`} >
            
            {handleRender(data.railcarType)}
        </div>
    </div>
    :
    // Railcar Info Display - Large View
    <div className={classes.buildRailcarGridEdit}>
        {
          cargoData[0] ? cargoData.map((c,i) => 
          <div 
            key={i}
            onClick={() => {handleSetDisplayCar(c.cargoEventId)}}
            className={`${classes.railcarIcon} ${classes.hoverRailcar} ${selectedUnitId === c.cargoEventId ? classes.selectedUnit : ""} ${handleSetPosition(c.cargoPosition)}`} >        
            {handleRender(c.cargoType, c.cargoProfileId.substring(0, 4).localeCompare("0000") === 0)}         
          </div>) : null
        }

        <div onClick={() => handleSetDisplayCar(null)} className={`${classes.railcarIconBottom} ${classes.hoverRailcar} ${!selectedUnitId ? classes.selectedUnit : ""} ${classes.level0}`} >          
            {handleRender(data.railcarType)}  
        </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(ComplexRailcar))

);